export default function updateBackorderLabel() {
    $('body').on('product:afterAttributeSelect', (e, response) => {
        const backorderVisibility = response.data.product.disabled && response.data.product.readyToOrder;
        const backorderLabel = $('.pdp-checkout-button .backorder-label');
        return backorderVisibility ? backorderLabel.removeClass('d-none') : backorderLabel.addClass('d-none');
    });
}
